import { useBlockProps } from '@wordpress/block-editor';


export const save = ( props ) => {
    const { attributes, setAttributes } = props;

    return (
        <div>
            <p style={{color: attributes.color }}>Content Property Price</p>
        </div>
    );
}
